import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=23d85eb7&scoped=true&"
import script from "./Allocation.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Allocation.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=23d85eb7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d85eb7",
  null
  
)

export default component.exports